import { extendTheme } from "@chakra-ui/react";

export default extendTheme({
  initialColorMode: "light",
  fonts: {
    heading: "Inter",
    body: "Inter",
  },
});
